module.exports = __webpack_public_path__ + "static/media/cash.21ddbdb9.svg";